// Translations for AqmOpti website
export const translations = {
  FR: {
    // Navigation
    nav: {
      home: "Accueil",
      services: "Optimisation",
      faq: "FAQ",
      reviews: "Vos Avis",
      benchmark: "Benchmark",
      search: "Rechercher...",
      navigation: "Navigation",
      performance: "Performance",
      ourNetworks: "Nos Réseaux",
      fpsEstimation: "Estimation FPS",
      benchmarkImprovement: "Benchmark & Amélioration"
    },
    
    // Header
    header: {
      loginDiscord: "Login Discord",
      online: "en ligne",
      registered: "inscrits"
    },

    // Hero Section
    hero: {
      badge: "Comment ça marche",
      title: "Votre Processus en",
      titleHighlight: "3 étapes",
      subtitle: "Découvrez le processus à suivre pour que votre PC atteigne son objectif.",
      step1: "ÉTAPE 1",
      step1Title: "Commandez votre pack",
      step1Desc: "Choisissez l'optimisation qui vous convient et passez commande en quelques clics.",
      step2: "ÉTAPE 2",
      step2Title: "On optimise votre PC",
      step2Desc: "Optimiser instantanément après le paiement, via notre application automatisée.",
      step3: "ÉTAPE 3",
      step3Title: "Profitez de vos gains",
      step3Desc: "Lancez vos jeux et constatez l'amélioration immédiate de vos performances."
    },

    // Main CTA
    cta: {
      badge: "Optimisation PC Gaming",
      title1: "Optimisez Votre",
      title2: "Expérience de Jeu",
      description: "Optimisations Windows & BIOS professionnelles. Plus de FPS, moins de latence, livrées en 24h.",
      discoverServices: "Découvrez nos services",
      seeReviews: "Voir les avis",
      optimizedPCs: "PC optimisés"
    },

    // Advantages
    advantages: {
      badge: "Nos avantages",
      title: "Pourquoi",
      titleHighlight: "AqmOpti",
      subtitle: "Des années d'expérience au service de vos performances",
      items: {
        performance: {
          title: "Performances Maximales",
          description: "Obtenez le meilleur de votre matériel avec nos optimisations professionnelles"
        },
        security: {
          title: "Sécurisé & Fiable",
          description: "Toutes nos optimisations sont testées et garanties sans risque"
        },
        support: {
          title: "Support 24/7",
          description: "Notre équipe est disponible pour vous accompagner à tout moment"
        },
        results: {
          title: "Résultats Garantis",
          description: "Améliorations mesurables et performances optimales garanties"
        },
        delivery: {
          title: "Optimiser Instantanément",
          description: "Service automatisé via notre application — votre PC est optimisé en quelques minutes"
        },
        expertise: {
          title: "Expertise Reconnue",
          description: "Des années d'expérience au service de vos performances gaming"
        }
      }
    },

    // Services
    services: {
      badge: "PC optimisés",
      title: "Nos",
      titleHighlight: "Services",
      subtitle: "Des optimisations professionnelles pour booster vos performances gaming",
      systemOptimization: "Optimisation du système",
      fullOptimization: "Optimisation complète",
      startingFrom: "À partir de",
      popular: "Populaire",
      windows: {
        name: "Service Windows",
        price: "19€",
        priceStandard: "19€",
        pricePriority: "23€",
        description: "Optimisation complète de Windows pour des performances maximales",
        features: [
          "Installation Windows AqmOS",
          "Optimisation Complète du Windows",
          "Optimisation du registre Windows",
          "Installation et optimisation des pilotes requis.",
          "Optimisation des logiciels requis (Discord, Spotify, OBS, steam etc.).",
          "Désactivation total des économies d'énergie",
          "Plan d'alimentation custom",
          "GameMode (reduction de la latence)",
          "Optimisation du stockage (SSD,HDD)",
          "Et bien plus encore .."
        ],
        requirements: "Clé USB (8 Go min), AnyDesk",
        discount: "13% de réduction sur les sessions répétées"
      },
      pack: {
        name: "Pack Complet",
        description: "Windows + BIOS inclus",
        features: [
          "Tout le Service Windows inclus",
          "Optimisation BIOS Intel/AMD",
          "Exploitation maximale des perfs",
          "Optimisation 1% et 0.1% lows",
          "Réduction latence globale",
          "Configuration BIOS personnalisée",
          "Support prioritaire inclus"
        ]
      },
      appTools: {
        name: "App-Tools",
        trial: {
          name: "Trial",
          price: "5€",
          description: "Essayez notre logiciel d'optimisation",
          features: ["Accès 30 jours", "Tweaks de base", "Interface intuitive"]
        },
        premium: {
          name: "Premium",
          price: "10€",
          description: "Version complète pour 6 mois",
          features: ["Accès 6 mois", "Tous les tweaks avancés", "Mises à jour régulières", "Support prioritaire"]
        },
        lifetime: {
          name: "Lifetime",
          price: "15€",
          description: "Accès à vie avec toutes les mises à jour",
          features: ["Accès illimité", "Tous les tweaks", "Mises à jour à vie", "Support VIP"]
        }
      },
      bios: {
        name: "Service BIOS",
        price: "13€",
        priceStandard: "13€",
        pricePriority: "17€",
        description: "Optimisation BIOS Intel / AMD",
        features: [
          "Exploitation maximale des performances système",
          "Amélioration des FPS moyens",
          "Optimisation des 1% et 0.1% lows",
          "Réduction significative de la latence globale",
          "Configuration BIOS personnalisée"
        ]
      },
      orderButton: "Commander",
      standard: "Standard",
      priority: "Prioritaire",
      successMessage: "Ticket créé avec succès sur Discord",
      activeOrderNotice: "Tu as déjà une commande en cours.",
      activeOrderHint: "Consulte ton ticket sur Discord pour suivre l'avancement.",
      loading: "En cours...",
      ticketCreated: "✓ Ticket créé !",
      loginToOrder: "Se connecter pour commander",
      total: "Total",
      biosIncluded: "+ Optimisation BIOS Incluse",
      cards: {
        savings: "Tu économises",
        endsIn: "Se termine dans",
        recommended: "Recommandé",
        bestValue: "Meilleur rapport qualité/prix",
        instantDelivery: "Livré instantanément après le paiement",
        reservedClients: "Réservé aux clients",
        clientsOnlyTitle: "Réservé aux clients (rôle Discord Clients)",
        windowsTagline: "Le pack qui rend ton PC vraiment gaming — configuré par un expert, 100% automatisé.",
        packTagline: "Stabilité FPS maximale et latence réduite. Optimisation Windows ET BIOS par un expert.",
        saveWord: "Économise",
        vsSeparately: "vs séparément",
        biosIncludedDesc: "Configuration avancée Intel/AMD pour des performances maximales",
        biosOnlyTitle: "Uniquement Optimisation BIOS",
        biosOnlySubtitle: "Pour clients déjà optimisés",
        biosFullHeading: "OPTIMISATION COMPLÈTE BIOS INTEL / AMD",
        biosLongDesc: "Cette optimisation BIOS exploite pleinement les performances de votre système : meilleurs FPS moyens, 1% et 0.1% lows améliorés, et latence globale réduite.",
        biosPrereqTitle: "Important — pré-requis",
        biosPrereqText: "Pour bénéficier de l'optimisation BIOS, il faut au préalable avoir pris le Service Windows, ou prendre directement le Pack Complet (plus rentable, légère réduction).",
        biosExclusivity: "Exclusivité Client",
        biosLockedHint: "🔒 Cette offre est réservée aux clients ayant déjà fait optimiser leur PC.",
        usesRecharge: "Recharge",
        usesTitle: "Acheter des utilisations",
        usesSubtitle: "Recharge ta licence existante",
        usesContains: "Contient toute l'optimisation du Service Windows",
        showDetails: "Afficher les détails",
        hideDetails: "Masquer les détails",
        moreText: "et bien plus encore…",
        atChoice: "Au choix :",
        usesEquiv: "1 utilisation = 1 optimisation complète Windows",
        usesAuto: "Optimiser Instantanément — Automatisé",
        fromLabel: "À partir de :",
        viewOffers: "Voir les offres",
        securePayment: "Paiement sécurisé",
        instantOptimize: "Optimiser Instantanément",
        instantOptimizeSub: "Automatisé via licence",
        support247: "Support 24/7",
        supportSub: "Assistance Discord",
        biosCompatTitle: "Compatibilité BIOS — important",
        biosNotCompatible: "Pas compatible :",
        biosNotCompatibleList: "portables, PC pré-montés (HP, Dell, Lenovo, Acer, Medion), cartes mères OEM",
        biosCompatible: "Compatible :",
        biosCompatibleList: "PC fixes assemblés (MSI, ASUS, Gigabyte, ASRock…)",
        ticketCreatedTitle: "Ticket créé",
        paymentVia: "Paiement via",
        serviceLabel: "Service",
        usesDetailsList: [
          "Installation AqmOs — Optimisation complète du Windows",
          "Optimisation du registre",
          "Pilotes installés & optimisés",
          "GameMode + Réduction latence",
          "Plan d'alimentation custom",
          "Stockage SSD/HDD optimisé",
          "Économies d'énergie désactivées",
          "Optimisation des logiciels requis (Spotify, Discord…)",
          "Bénéficie de toutes les prochaines mises à jour de l'opti"
        ]
      },
      modal: {
        orderTitle: "Commander",
        selectOptions: "Sélectionnez vos options",
        priorityOption: "Option Prioritaire",
        priorityDesc: "Traitement en priorité - Votre commande passe avant toutes les autres",
        priorityHint: "Livraison plus rapide • Support dédié",
        preparationOption: "Option Préparation",
        preparationDesc: "On s'occupe de tout à votre place : on suit pour vous, étape par étape, tous nos tutoriels ultra-simples (réinstallation de Windows incluse). Vous n'avez rien à faire, notre équipe fait tout pour vous.",
        preparationHint: "On suit nos tutos à votre place • Vous n'avez rien à faire",
        preparationTooltip: "On s'occupe de TOUT à votre place !",
        preparationTooltipDesc: "On suit pour vous, étape par étape, tous nos tutoriels ultra-simples (réinstallation de Windows incluse). Vous n'avez rien à faire, notre équipe fait tout pour vous.",
        referralCode: "Code de parrainage",
        referralPlaceholder: "Entrez un code (optionnel)",
        totalPrice: "Prix Total",
        confirmOrder: "Confirmer la commande",
        cancel: "Annuler",
        processing: "Traitement..."
      }
    },

    // Footer
    footer: {
      tagline: "Optimisation Gaming Ultime",
      copyright: "© 2026 AqmOpti. Tous droits réservés."
    },

    // Benchmark
    benchmark: {
      badge: "Performance",
      title: "Benchmark",
      titleHighlight: "Gaming",
      subtitle: "Résultats réels avant et après optimisation AqmOpti",
      before: "Avant",
      after: "Après",
      optimizedBy: "Optimisé par AqmOpti",
      averageFPS: "FPS Moyen",
      low1FPS: "1% Low",
      low02FPS: "0.2% Low",
      performanceGains: "Gains de Performance",
      avgFPS: "FPS Moyen",
      comparison: "Comparaison",
      beforeList: {
        freezes: "Freezes fréquents",
        latency: "Latence élevée",
        stutters: "Stutters réguliers",
        drops: "Drops de FPS",
        unoptimized: "Système non optimisé"
      },
      afterList: {
        smooth: "Gameplay fluide",
        minimalLatency: "Latence minimale",
        noStutter: "Aucun stutter",
        stableFPS: "FPS stables",
        maxOptimization: "Optimisation maximale"
      },
      systemConfig: "Configuration Système",
      processor: "Processeur",
      gpu: "Carte Graphique",
      ram: "Mémoire RAM",
      storage: "Stockage",
      newTest: "Commander une Optimisation",
      recommendation: "💡 Recommandation :",
      recommendationText: "Les résultats peuvent varier selon votre configuration matérielle. Nos optimisations sont personnalisées pour maximiser vos performances."
    },

    // Referral Page
    referral: {
      title: "Programme de Parrainage",
      loginPrompt: "Connectez-vous pour accéder à votre code de parrainage et gagner des récompenses",
      loginButton: "Se connecter avec Discord",
      loading: "Chargement...",
      headerBadge: "Programme de Parrainage",
      headerTitle: "Parrainez & Gagnez des",
      headerHighlight: "Récompenses",
      headerSubtitle: "Invitez vos amis et gagnez 10 points par parrainage. Échangez vos points contre des optimisations gratuites !",
      totalPoints: "Points totaux",
      successfulReferrals: "Parrainages réussis",
      pointsGenerated: "Points générés",
      yourCode: "Votre Code de Parrainage",
      personalCode: "Code personnel",
      copyLink: "Copier le lien de parrainage",
      linkCopied: "Lien copié !",
      shareInfo: "Partagez ce lien avec vos amis pour gagner 10 points par inscription",
      howItWorks: "Comment ça marche ?",
      step1: "Partagez votre code",
      step1Desc: "Envoyez votre lien à vos amis",
      step2: "Ils s'inscrivent",
      step2Desc: "Vos amis créent un compte",
      step3: "Ils commandent un service",
      step3Desc: "Windows: 10-12 pts • Pack: 15-18 pts",
      step4: "Réclamez vos récompenses",
      step4Desc: "Échangez vos points contre des services",
      pointsPerService: "Gain de points par service :",
      haveCode: "Vous avez un code de parrainage ?",
      haveCodeDesc: "Si un ami vous a parrainé, entrez son code pour lui faire gagner des points quand vous commandez !",
      validate: "Valider",
      verifying: "Vérification...",
      oneCodeWarning: "Vous ne pouvez utiliser qu'un seul code de parrainage par compte",
      availableRewards: "Récompenses Disponibles",
      rewardsLimits: "Limites de récompenses :",
      windowsLimit: "Max 3 personnes pour Windows",
      packLimit: "Max 1 personne pour Pack Complet",
      remainingSlots: "Places restantes :",
      windowsService: "Service Windows",
      fullOptimization: "Optimisation complète",
      packComplet: "Pack Complet",
      windowsBios: "Windows + BIOS",
      progression: "Progression",
      claimReward: "Réclamer la récompense",
      claiming: "Réclamation...",
      pointsNeeded: "points nécessaires",
      still: "Encore",
      yourReferrals: "Vos Parrainages"
    },

    // Feedbacks Page
    feedbacks: {
      badge: "Témoignages",
      title: "Avis",
      titleHighlight: "Clients",
      subtitle: "Découvrez ce que nos clients pensent de nos services",
      verifiedReviews: "Avis vérifiés",
      onDiscord: "sur Discord",
      averageRating: "Note moyenne",
      satisfaction: "Satisfaction",
      refresh: "Actualiser",
      loading: "Chargement des avis...",
      error: "Erreur lors du chargement des avis",
      retry: "Réessayer",
      reviewsOnDiscord: "Les avis sont sur Discord !",
      reviewsOnDiscordDesc: "Retrouvez tous nos avis clients directement sur notre serveur Discord",
      viewOnDiscord: "Voir les avis sur Discord",
      verified: "Vérifié",
      leaveReview: "Laissez votre avis !",
      shareExperience: "Partagez votre expérience sur notre Discord",
      joinDiscord: "Rejoindre le Discord"
    },

    // My Orders Page
    myOrders: {
      badge: "Mon Compte",
      title: "Mes",
      titleHighlight: "Commandes",
      subtitle: "Retrouve l'historique de toutes tes commandes",
      loginPrompt: "Connecte-toi avec Discord pour voir tes commandes",
      loginButton: "Se connecter avec Discord",
      loading: "Chargement...",
      noOrders: "Aucune commande",
      noOrdersDesc: "Tu n'as pas encore passé de commande",
      viewServices: "Voir les services",
      pending: "En attente",
      inProgress: "En cours",
      completed: "Terminé",
      progressPaid: "Payé",
      invoicePdf: "Facture PDF",
      viewTicket: "Voir ticket",
      downloadError: "Erreur lors du téléchargement de la facture"
    },

    // Sidebar
    sidebar: {
      account: "Compte",
      myOrders: "Mes Commandes",
      clientSpace: "Espace Client",
      windowsTutorials: "Tutoriels Windows",
      logout: "Déconnexion",
      satisfiedClients: "Clients satisfaits",
      parrainage: "Parrainage"
    },

    // Header
    header: {
      referralPoints: "Points de Parrainage",
      clickToSeeRewards: "Cliquez pour voir vos récompenses",
      discordRoles: "Rôles Discord",
      adminPanel: "Panel Admin",
      notifications: "Notifications",
      noNotifications: "Aucune notification",
      markAllRead: "Tout lu"
    },

    // FAQ
    faq: {
      badge: "Questions Fréquentes",
      title: "Foire Aux",
      titleHighlight: "Questions",
      subtitle: "Trouvez les réponses à toutes vos questions sur nos services d'optimisation PC",
      contactTitle: "Vous avez encore des questions ?",
      contactSubtitle: "Rejoignez notre Discord pour obtenir de l'aide de notre équipe",
      contactButton: "Rejoindre Discord",
      items: [
        {
          question: "Combien de temps dure l'optimisation et comment se déroule-t-elle ?",
          answer: "Une fois votre commande validée, un tutoriel pour installer Windows vous est transmis. Il suffit de le suivre — en une trentaine de minutes, votre système est intégralement paramétré et optimisé. Tout est automatisé, vous n'avez aucune opération technique à effectuer."
        },
        {
          question: "Quels gains de performance puis-je espérer ?",
          answer: "Les gains réels varient avant tout selon votre configuration d'origine et l'état dans lequel se trouve votre système. Annoncer un chiffre précis d'FPS supplémentaires est impossible, car le résultat dépend de multiples éléments : votre matériel, les jeux que vous lancez, les programmes installés et vos paramètres actuels. En pratique, ce sont surtout la fluidité globale, la baisse des latences et une stabilité accrue des performances qui se ressentent le plus."
        },
        {
          question: "Les optimisations peuvent-elles endommager mon PC ?",
          answer: "Non, chacune de nos optimisations est testée et parfaitement sûre. Nous ne sollicitons jamais le matériel au-delà de seuils raisonnables, et nous réalisons des tests de stabilité sur les configurations avancées afin d'en assurer la fiabilité."
        },
        {
          question: "Comment commander une optimisation ?",
          answer: "Tout se passe directement via https://aqmoptimisation.fr/services. Vous pouvez régler par PayPal, Apple Pay ou la plupart des cartes bancaires, le paiement étant à effectuer avant le démarrage de la prestation."
        },
        {
          question: "Proposez-vous un service après-vente ?",
          answer: "Oui. Nous proposons un accompagnement technique continu, avec des ajustements lorsque c'est nécessaire et des conseils sur mesure, dans le but de préserver la stabilité et les performances de votre système.\n\nCependant, certaines manipulations réalisées sans notre accord explicite mettent automatiquement fin à ce suivi. Sont notamment concernés l'installation de la NVIDIA App ou de tout autre logiciel capable de modifier les paramètres système, l'usage de scripts batch (.bat), les mises à jour Windows, les fichiers de registre (.reg), ainsi que toute autre intervention non validée au préalable par notre équipe.\n\nPour conserver l'intégrité des optimisations effectuées, il est indispensable de ne rien modifier sans nous consulter. Une action non autorisée risque d'annuler les bénéfices obtenus et de fragiliser la stabilité de votre système."
        }
      ]
    }
  },

  EN: {
    // Navigation
    nav: {
      home: "Home",
      services: "Optimization",
      faq: "FAQ",
      reviews: "Reviews",
      benchmark: "Benchmark",
      search: "Search...",
      navigation: "Navigation",
      performance: "Performance",
      ourNetworks: "Our Networks",
      fpsEstimation: "FPS Estimation",
      benchmarkImprovement: "Benchmark & Amélioration"
    },

    // Header
    header: {
      loginDiscord: "Login Discord",
      online: "online",
      registered: "registered"
    },

    // Hero Section
    hero: {
      badge: "How it works",
      title: "Your Process in",
      titleHighlight: "3 Steps",
      subtitle: "Discover the process to follow so your PC reaches its goal.",
      step1: "STEP 1",
      step1Title: "Order your pack",
      step1Desc: "Choose the optimization that suits you and order in just a few clicks.",
      step2: "STEP 2",
      step2Title: "We optimize your PC",
      step2Desc: "Instantly optimize after payment, via our automated application.",
      step3: "STEP 3",
      step3Title: "Enjoy your gains",
      step3Desc: "Launch your games and see the immediate improvement in your performance."
    },

    // Main CTA
    cta: {
      badge: "PC Gaming Optimization",
      title1: "Optimize Your",
      title2: "Gaming Experience",
      description: "Professional Windows & BIOS optimizations. More FPS, less latency, delivered in 24h.",
      discoverServices: "Discover our services",
      seeReviews: "See reviews",
      optimizedPCs: "PCs optimized"
    },

    // Advantages
    advantages: {
      badge: "Our advantages",
      title: "Why",
      titleHighlight: "AqmOpti",
      subtitle: "Years of experience at the service of your performance",
      items: {
        performance: {
          title: "Maximum Performance",
          description: "Get the best from your hardware with our professional optimizations"
        },
        security: {
          title: "Secure & Reliable",
          description: "All our optimizations are tested and guaranteed risk-free"
        },
        support: {
          title: "24/7 Support",
          description: "Our team is available to assist you at any time"
        },
        results: {
          title: "Guaranteed Results",
          description: "Measurable improvements and optimal performance guaranteed"
        },
        delivery: {
          title: "Optimize Instantly",
          description: "Automated service via our application — your PC is optimized in minutes"
        },
        expertise: {
          title: "Recognized Expertise",
          description: "Years of experience serving your gaming performance"
        }
      }
    },

    // Services
    services: {
      badge: "Our Services",
      title: "Our Optimization",
      titleHighlight: "Services",
      subtitle: "Choose the pack that fits your needs",
      windows: {
        name: "Windows Service",
        price: "30€",
        description: "Complete Windows optimization for maximum performance",
        features: ["Disable unnecessary services", "Registry optimization", "Advanced network configuration", "Optimal power settings", "Gaming system tweaks", "24/7 Discord support"]
      },
      appTools: {
        name: "App-Tools",
        trial: {
          name: "Trial",
          price: "5€",
          description: "Try our optimization software",
          features: ["30-day access", "Basic tweaks", "Intuitive interface"]
        },
        premium: {
          name: "Premium",
          price: "10€",
          description: "Full version for 6 months",
          features: ["6-month access", "All advanced tweaks", "Regular updates", "Priority support"]
        },
        lifetime: {
          name: "Lifetime",
          price: "15€",
          description: "Lifetime access with all updates",
          features: ["Unlimited access", "All tweaks", "Lifetime updates", "VIP support"]
        }
      },
      bios: {
        name: "BIOS Service",
        price: "15€",
        description: "Advanced BIOS optimization",
        features: ["Optimal BIOS configuration", "Safe overclocking", "Memory timings", "CPU/GPU settings", "Additional performance gains"]
      },
      orderButton: "Order"
    },

    // Footer
    footer: {
      tagline: "The Art of PC Optimization",
      copyright: "© 2026 AqmOpti. All rights reserved."
    },

    // Services
    services: {
      badge: "PCs optimized",
      title: "Our",
      titleHighlight: "Services",
      subtitle: "Professional optimizations to boost your gaming performance",
      systemOptimization: "System optimization",
      fullOptimization: "Full optimization",
      startingFrom: "Starting from",
      popular: "Popular",
      windows: {
        name: "Windows Service",
        price: "19€",
        priceStandard: "19€",
        pricePriority: "23€",
        description: "Complete Windows optimization for maximum performance",
        features: [
          "Custom Windows ISO installation",
          "Complete Windows Optimization",
          "Windows registry optimization",
          "Required drivers installation and optimization",
          "Required software optimization (Discord, Spotify, OBS, etc.)",
          "Power saving disabled + startup script",
          "Custom power plan",
          "Latency improvement + GameMode",
          "Storage optimization (SSD, HDD)",
          "And much more..."
        ],
        requirements: "USB key (8 GB min), AnyDesk",
        discount: "13% discount on repeated sessions"
      },
      pack: {
        name: "Full Pack",
        description: "Windows + BIOS included",
        features: [
          "Full Windows Service included",
          "Intel/AMD BIOS optimization",
          "Maximum performance exploitation",
          "1% and 0.1% lows optimization",
          "Overall latency reduction",
          "Custom BIOS configuration",
          "Priority support included"
        ]
      },
      appTools: {
        name: "App-Tools",
        trial: {
          name: "Trial",
          price: "5€",
          description: "Try our optimization software",
          features: ["30-day access", "Basic tweaks", "Intuitive interface"]
        },
        premium: {
          name: "Premium",
          price: "10€",
          description: "Full version for 6 months",
          features: ["6-month access", "All advanced tweaks", "Regular updates", "Priority support"]
        },
        lifetime: {
          name: "Lifetime",
          price: "15€",
          description: "Lifetime access with all updates",
          features: ["Unlimited access", "All tweaks", "Lifetime updates", "VIP support"]
        }
      },
      bios: {
        name: "BIOS Service",
        price: "13€",
        priceStandard: "13€",
        pricePriority: "17€",
        description: "Intel / AMD BIOS optimization",
        features: [
          "Maximum system performance exploitation",
          "Average FPS improvement",
          "1% and 0.1% lows optimization",
          "Significant overall latency reduction",
          "Custom BIOS configuration"
        ]
      },
      orderButton: "Order Now",
      standard: "Standard",
      priority: "Priority",
      successMessage: "Ticket successfully created on Discord",
      activeOrderNotice: "You already have an active order.",
      activeOrderHint: "Check your Discord ticket to follow the progress.",
      loading: "Loading...",
      ticketCreated: "✓ Ticket created!",
      loginToOrder: "Login to order",
      total: "Total",
      biosIncluded: "+ BIOS Optimization Included",
      cards: {
        savings: "You save",
        endsIn: "Ends in",
        recommended: "Recommended",
        bestValue: "Best value for money",
        instantDelivery: "Delivered instantly after payment",
        reservedClients: "Clients only",
        clientsOnlyTitle: "Clients only (Discord Clients role)",
        windowsTagline: "The pack that makes your PC truly gaming — set up by an expert, 100% automated.",
        packTagline: "Maximum FPS stability and reduced latency. Windows AND BIOS optimization by an expert.",
        saveWord: "Save",
        vsSeparately: "vs separately",
        biosIncludedDesc: "Advanced Intel/AMD configuration for maximum performance",
        biosOnlyTitle: "BIOS Optimization Only",
        biosOnlySubtitle: "For already-optimized clients",
        biosFullHeading: "COMPLETE INTEL / AMD BIOS OPTIMIZATION",
        biosLongDesc: "This BIOS optimization fully unlocks your system's performance: higher average FPS, improved 1% and 0.1% lows, and reduced overall latency.",
        biosPrereqTitle: "Important — prerequisites",
        biosPrereqText: "To get the BIOS optimization, you must first have taken the Windows Service, or go directly for the Full Pack (better value, slight discount).",
        biosExclusivity: "Client Exclusive",
        biosLockedHint: "🔒 This offer is reserved for clients who already had their PC optimized.",
        usesRecharge: "Recharge",
        usesTitle: "Buy usages",
        usesSubtitle: "Top up your existing license",
        usesContains: "Includes the full Windows Service optimization",
        showDetails: "Show details",
        hideDetails: "Hide details",
        moreText: "and much more…",
        atChoice: "Your choice:",
        usesEquiv: "1 usage = 1 full Windows optimization",
        usesAuto: "Optimize Instantly — Automated",
        fromLabel: "Starting from:",
        viewOffers: "View offers",
        securePayment: "Secure payment",
        instantOptimize: "Optimize Instantly",
        instantOptimizeSub: "Automated via license",
        support247: "24/7 Support",
        supportSub: "Discord assistance",
        biosCompatTitle: "BIOS compatibility — important",
        biosNotCompatible: "Not compatible:",
        biosNotCompatibleList: "laptops, pre-built PCs (HP, Dell, Lenovo, Acer, Medion), OEM motherboards",
        biosCompatible: "Compatible:",
        biosCompatibleList: "custom-built desktops (MSI, ASUS, Gigabyte, ASRock…)",
        ticketCreatedTitle: "Ticket created",
        paymentVia: "Payment via",
        serviceLabel: "Service",
        usesDetailsList: [
          "AqmOs installation — Full Windows optimization",
          "Registry optimization",
          "Drivers installed & optimized",
          "GameMode + Latency reduction",
          "Custom power plan",
          "SSD/HDD storage optimized",
          "Power saving disabled",
          "Required software optimization (Spotify, Discord…)",
          "Get all future optimization updates"
        ]
      },
      modal: {
        orderTitle: "Order",
        selectOptions: "Select your options",
        priorityOption: "Priority Option",
        priorityDesc: "Priority processing - Your order goes before all others",
        priorityHint: "Faster delivery • Dedicated support",
        preparationOption: "Preparation Option",
        preparationDesc: "We handle everything for you: step by step, we follow all our ultra-simple tutorials on your behalf (Windows reinstallation included). You do nothing, our team does it all for you.",
        preparationHint: "We follow our tutorials for you • You do nothing",
        preparationTooltip: "We handle EVERYTHING for you!",
        preparationTooltipDesc: "Step by step, we follow all our ultra-simple tutorials on your behalf (Windows reinstallation included). You do nothing, our team does it all for you.",
        referralCode: "Referral code",
        referralPlaceholder: "Enter a code (optional)",
        totalPrice: "Total Price",
        confirmOrder: "Confirm order",
        cancel: "Cancel",
        processing: "Processing..."
      }
    },

    // Benchmark
    benchmark: {
      badge: "Performance",
      title: "Benchmark",
      titleHighlight: "Gaming",
      subtitle: "Real results before and after AqmOpti optimization",
      before: "Before",
      after: "After",
      optimizedBy: "Optimized by AqmOpti",
      averageFPS: "Average FPS",
      low1FPS: "1% Low",
      low02FPS: "0.2% Low",
      performanceGains: "Performance Gains",
      avgFPS: "Average FPS",
      comparison: "Comparison",
      beforeList: {
        freezes: "Frequent freezes",
        latency: "High latency",
        stutters: "Regular stutters",
        drops: "FPS drops",
        unoptimized: "Unoptimized system"
      },
      afterList: {
        smooth: "Smooth gameplay",
        minimalLatency: "Minimal latency",
        noStutter: "No stutters",
        stableFPS: "Stable FPS",
        maxOptimization: "Maximum optimization"
      },
      systemConfig: "System Configuration",
      processor: "Processor",
      gpu: "Graphics Card",
      ram: "Memory",
      storage: "Storage",
      newTest: "Order an Optimization",
      recommendation: "💡 Recommendation:",
      recommendationText: "Results may vary depending on your hardware configuration. Our optimizations are personalized to maximize your performance."
    },

    // Referral Page
    referral: {
      title: "Referral Program",
      loginPrompt: "Log in to access your referral code and earn rewards",
      loginButton: "Login with Discord",
      loading: "Loading...",
      headerBadge: "Referral Program",
      headerTitle: "Refer & Earn",
      headerHighlight: "Rewards",
      headerSubtitle: "Invite your friends and earn 10 points per referral. Redeem your points for free optimizations!",
      totalPoints: "Total points",
      successfulReferrals: "Successful referrals",
      pointsGenerated: "Points generated",
      yourCode: "Your Referral Code",
      personalCode: "Personal code",
      copyLink: "Copy referral link",
      linkCopied: "Link copied!",
      shareInfo: "Share this link with your friends to earn 10 points per registration",
      howItWorks: "How it works?",
      step1: "Share your code",
      step1Desc: "Send your link to your friends",
      step2: "They sign up",
      step2Desc: "Your friends create an account",
      step3: "They order a service",
      step3Desc: "Windows: 10-12 pts • Pack: 15-18 pts",
      step4: "Claim your rewards",
      step4Desc: "Redeem your points for services",
      pointsPerService: "Points earned per service:",
      haveCode: "Have a referral code?",
      haveCodeDesc: "If a friend referred you, enter their code to help them earn points when you order!",
      validate: "Validate",
      verifying: "Verifying...",
      oneCodeWarning: "You can only use one referral code per account",
      availableRewards: "Available Rewards",
      rewardsLimits: "Reward limits:",
      windowsLimit: "Max 3 people for Windows",
      packLimit: "Max 1 person for Full Pack",
      remainingSlots: "Remaining slots:",
      windowsService: "Windows Service",
      fullOptimization: "Full optimization",
      packComplet: "Full Pack",
      windowsBios: "Windows + BIOS",
      progression: "Progress",
      claimReward: "Claim reward",
      claiming: "Claiming...",
      pointsNeeded: "points needed",
      still: "Still",
      yourReferrals: "Your Referrals"
    },

    // Feedbacks Page
    feedbacks: {
      badge: "Testimonials",
      title: "Customer",
      titleHighlight: "Reviews",
      subtitle: "Discover what our customers think about our services",
      verifiedReviews: "Verified reviews",
      onDiscord: "on Discord",
      averageRating: "Average rating",
      satisfaction: "Satisfaction",
      refresh: "Refresh",
      loading: "Loading reviews...",
      error: "Error loading reviews",
      retry: "Retry",
      reviewsOnDiscord: "Reviews are on Discord!",
      reviewsOnDiscordDesc: "Find all our customer reviews directly on our Discord server",
      viewOnDiscord: "View reviews on Discord",
      verified: "Verified",
      leaveReview: "Leave your review!",
      shareExperience: "Share your experience on our Discord",
      joinDiscord: "Join Discord"
    },

    // My Orders Page
    myOrders: {
      badge: "My Account",
      title: "My",
      titleHighlight: "Orders",
      subtitle: "Find the history of all your orders",
      loginPrompt: "Log in with Discord to see your orders",
      loginButton: "Login with Discord",
      loading: "Loading...",
      noOrders: "No orders",
      noOrdersDesc: "You haven't placed any orders yet",
      viewServices: "View services",
      pending: "Pending",
      inProgress: "In progress",
      completed: "Completed",
      progressPaid: "Paid",
      invoicePdf: "PDF Invoice",
      viewTicket: "View ticket",
      downloadError: "Error downloading invoice"
    },

    // Sidebar
    sidebar: {
      account: "Account",
      myOrders: "My Orders",
      clientSpace: "Client Space",
      windowsTutorials: "Windows Tutorials",
      logout: "Logout",
      satisfiedClients: "Satisfied clients",
      parrainage: "Referral"
    },

    // Header
    header: {
      referralPoints: "Referral Points",
      clickToSeeRewards: "Click to see your rewards",
      discordRoles: "Discord Roles",
      adminPanel: "Admin Panel",
      notifications: "Notifications",
      noNotifications: "No notifications",
      markAllRead: "Mark all read"
    },

    // FAQ
    faq: {
      badge: "Frequently Asked Questions",
      title: "Frequently Asked",
      titleHighlight: "Questions",
      subtitle: "Find answers to all your questions about our PC optimization services",
      contactTitle: "Still have questions?",
      contactSubtitle: "Join our Discord to get help from our team",
      contactButton: "Join Discord",
      items: [
        {
          question: "How long does the optimization take and how does it work?",
          answer: "Once your order is validated, a tutorial to install Windows is sent to you. Just follow it — in about thirty minutes, your system is fully configured and optimized. Everything is automated, you have no technical operation to perform."
        },
        {
          question: "What performance gains can I expect?",
          answer: "Actual gains vary primarily based on your original configuration and the state of your system. Announcing a precise additional FPS number is impossible, as the result depends on multiple factors: your hardware, the games you play, installed programs and your current settings. In practice, it's mainly overall fluidity, reduced latency, and increased performance stability that are most noticeable."
        },
        {
          question: "Can optimizations damage my PC?",
          answer: "No, each of our optimizations is tested and perfectly safe. We never push the hardware beyond reasonable thresholds, and we perform stability tests on advanced configurations to ensure reliability."
        },
        {
          question: "How do I order an optimization?",
          answer: "Everything happens directly via https://aqmoptimisation.fr/services. You can pay via PayPal, Apple Pay or most credit cards. Payment must be made before the service starts."
        },
        {
          question: "Do you offer after-sales support?",
          answer: "Yes. We offer continuous technical support, with adjustments when necessary and tailored advice, aimed at preserving the stability and performance of your system.\n\nHowever, certain manipulations performed without our explicit agreement automatically end this support. This includes installing the NVIDIA App or any other software capable of modifying system settings, the use of batch scripts (.bat), Windows updates, registry files (.reg), as well as any other intervention not validated beforehand by our team.\n\nTo preserve the integrity of the optimizations performed, it is essential not to modify anything without consulting us. An unauthorized action may cancel the benefits obtained and weaken the stability of your system."
        }
      ]
    }
  }
};

export default translations;
